import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["aria-hidden"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["modal fade", [{
        'show d-block': $props.show
      }, {
        'd-none': !$props.show
      }, {
        'modal-mini': $props.type === 'mini'
      }]]),
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.closeModal && $options.closeModal(...args), ["self"])),
      tabindex: "-1",
      role: "dialog",
      "aria-hidden": !$props.show
    }, [_createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", [{
        'modal-notice': $props.type === 'notice',
        [`modal-${$props.size}`]: $props.size
      }, $props.modalClasses]])
    }, [_createElementVNode("div", {
      class: _normalizeClass(["modal-content", [$props.gradient ? `bg-gradient-${$props.gradient}` : '', $props.modalContentClasses]])
    }, [_ctx.$slots.header ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["modal-header", [$props.headerClasses]])
    }, [_renderSlot(_ctx.$slots, "header"), _renderSlot(_ctx.$slots, "close-button", {}, () => [$props.showClose ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: 0,
      "aria-hidden": !$props.show,
      icon: ['far', 'circle-xmark'],
      size: "lg",
      onClick: $options.closeModal,
      "data-dismiss": "modal",
      "aria-label": "Close"
    }, null, 8, ["aria-hidden", "onClick"])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(["modal-body", $props.bodyClasses])
    }, [_renderSlot(_ctx.$slots, "default")], 2), _ctx.$slots.footer ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass(["modal-footer", $props.footerClasses])
    }, [_renderSlot(_ctx.$slots, "footer")], 2)) : _createCommentVNode("", true)], 2)], 2)], 10, _hoisted_1), [[_vShow, $props.show]])]),
    _: 3
  });
}